import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import RetinaImageWrapper from "../../components/RetinaImage"
import { graphql } from "gatsby"
import nl2br from "../../utils/nl2br"
import "./styles.less"

export default ({ data }) => {
  const pageData = data.cms.pageData
  const press = data.cms.press

  return (
    <Layout>
      <SEO
        title={pageData.metaTitle}
        description={pageData.metaDescription}
        image={
          pageData.metaImage[0]
            ? pageData.metaImage[0].url
            : pageData.coverImage[0].url
        }
        jsonSchema={pageData.jsonSchema}
      />

      <div className="container why-workplace-one">
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <h1>{nl2br(pageData.pageTitle)}</h1>
            <p>{nl2br(pageData.pageSubtitle)}</p>
          </div>

          {pageData.coverImage.length > 0 && (
            <div className="col-sm-12">
              <div className="cover-images single-image">
                <div>
                  <RetinaImageWrapper
                    image={pageData.coverImage[0]}
                    retinaImage={pageData.coverImageRetina[0]}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <section>
        <div className="container">
          <hr className="d-sm-none my-0" />
          {pageData.whySections.map((item, idx) => (
            <WhyBlock key={idx} number={idx + 1} item={item} />
          ))}
        </div>
      </section>

      <section className="testimonials">
        <div className="container">
          <div className="testimonial-inner">
            <div className="inner-wrapper">
              <div className="row">
                {pageData.whyTestimonials.map(
                  ({ testText, testPerson }, idx) => (
                    <div
                      className={idx === 0 ? "col-sm-12" : "col-sm-6"}
                      key={idx}
                    >
                      <div className={`block block-${idx}`}>
                        <p>{testText}</p>
                        <span>{testPerson}</span>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="press">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h2>In the press</h2>
            </div>
            {press.map(({ title, pressSource, pressLink }, idx) => (
              <div className="col-sm-6 col-lg-4 press-block" key={idx}>
                <a
                  href={pressLink}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <h4>{title}</h4>
                  <span>{pressSource}</span>
                  <span className={"link"}>Learn More</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {pageData.acknowledgement ? (
        <section className={"why-workplace-one-acknowledgment"}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-10 col-lg-9 col-xl-7">
                <h2>Acknowledgment </h2>
                {pageData.acknowledgement.split("\n").map((text, idx) => (
                  <p key={idx}>{text}</p>
                ))}
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
    </Layout>
  )
}

const WhyBlock = ({ number, item }) => {
  return (
    <div className="why-block">
      <div className="row">
        <div className="col-md-6 offset-md-1 order-md-2 d-flex align-items-center">
          <div className="img-3-2">
            <RetinaImageWrapper
              image={item.whyImage[0]}
              retinaImage={item.whyImageRetina[0]}
            />
          </div>
        </div>
        <div className="col-md-5 d-flex align-items-center order-md-1">
          <div>
            <span>0{number}</span>
            <h2>{item.whyTitle}</h2>
            <p>{nl2br(item.whyText)}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query {
    cms {
      press: entries(section: "inThePress", limit: 100) {
        id
        ... on Cms_inThePress_inThePress_Entry {
          id
          title
          pressLink
          pressSource
        }
      }
      pageData: entry(section: "whyWorkplaceOne") {
        id
        ... on Cms_whyWorkplaceOne_aboutPage_Entry {
          id
          acknowledgement: amenities
          coverImage {
            url(width: 1280, height: 720)
            title
          }
          coverImageRetina: coverImage {
            url(width: 2560, height: 1440)
            title
          }
          metaTitle
          metaDescription
          metaImage {
            url(width: 1200, height: 630)
          }
          jsonSchema
          pageTitle
          pageSubtitle
          whyTestimonials {
            ... on Cms_whyTestimonials_testimonial_BlockType {
              id
              testText
              testPerson
            }
          }
          whySections {
            ... on Cms_whySections_whySection_BlockType {
              id
              whyTitle
              whyText
              whyImage {
                url(width: 600, height: 400)
                title
              }
              whyImageRetina: whyImage {
                url(width: 1200, height: 800)
                title
              }
            }
          }
        }
      }
    }
  }
`
